var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-jumbotron',{attrs:{"header":"💯","lead":""}},[_c('p',[_vm._v(" A hundred items "),_c('br'),_vm._v(" Curated and categorized ")]),_c('InfoModal')],1),_c('Items'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }